
import { createContext, useContext } from 'react';

export const UrlContext = createContext();

export function useUrlContext() {
  return useContext(UrlContext);
}
